import LoadingButton from "@mui/lab/LoadingButton"
import Button from "@mui/material/Button"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import Typography from "@mui/material/Typography"

import DialogHeader from "../components/DialogHeader"

export default function ConfirmDisconnectPhoneDialog({
  open,
  onClose,
  onConfirm,
  phone,
  isLoading = false,
}) {
  return (
    <Dialog
      open={open}
      onClose={() => !isLoading && onClose?.()}
      maxWidth="xs"
      fullWidth
    >
      <DialogHeader
        title="Disconnect Phone Number"
        onClose={() => !isLoading && onClose?.()}
      />
      <DialogContent>
        <Typography variant="body1">
          Are you sure you want to disconnect <strong>{phone}</strong>?
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
          You will need to verify a new phone number before you can make calls
          to candidates.
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button variant="outlined" onClick={onClose} disabled={isLoading}>
          Cancel
        </Button>
        <LoadingButton
          variant="contained"
          color="error"
          loading={isLoading}
          onClick={onConfirm}
        >
          Disconnect
        </LoadingButton>
      </DialogActions>
    </Dialog>
  )
}
